import { render, staticRenderFns } from "./iDalgo-Liveblogs.vue?vue&type=template&id=9f7c4a74"
import script from "./iDalgo-Liveblogs.vue?vue&type=script&lang=js"
export * from "./iDalgo-Liveblogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports